import React from 'react';
import { useBreakpoint } from './BreakpointProvider';
import { CONTENT_GUTTER, CONTENT_MAX_WIDTH } from './constants';

interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: number;
  style?: React.CSSProperties;
}

// Desktop: centres the page at maxWidth with the shell's side gutters.
// Phone and tablet: renders the children untouched, so the mobile layout is unchanged.
const PageContainer = ({ children, maxWidth = CONTENT_MAX_WIDTH, style }: PageContainerProps) => {
  const { isDesktop } = useBreakpoint();
  if (!isDesktop) return <>{children}</>;
  return (
    <div style={{
      maxWidth,
      margin: '0 auto',
      padding: `24px ${CONTENT_GUTTER}px 48px`,
      boxSizing: 'border-box',
      ...style,
    }}>
      {children}
    </div>
  );
};

export default PageContainer;
